import { Box, Container, Grid, Stack, Tab, Tabs } from '@mui/material';
import Card from '@mui/material/Card';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Actionbutton from '../../components/Actionbutton';
import { commonUtils } from '../../utils/utils';
import { CustomTabPanel, a11yProps } from '../../components/CustomTabPanel';
import DeleteModel from '../../components/Deletemodle';
import Header from '../../components/Header';
import Claim from '../../components/claim/Claim';
import Notes from '../../components/note/Note';
import { apidelete, apiget } from '../../service/api';
import AddModel from './Add';
import EditModel from './Edit';
import Moreinformation from './Moreinformation';
import Other from './Other';
import Overview from './Overview';
import ProjectDocuments from './projectDocument/projectDocuments';

const View = () => {

    const [projectData, setProjectData] = useState({});
    const [userAction, setUserAction] = useState(null);
    const [openAdd, setOpenAdd] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [opendelete, setOpendelete] = useState(false);
    const [value, setValue] = useState(0);
    const [isVisibleClaim, setIsVisibleClaim] = useState(false);
    const [isVisibleNotes, setIsVisibleNotes] = useState(false);
    const [isVisibleProjectDoc, setIsVisibleProjectDoc] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const params = useParams()
    const navigate = useNavigate()

    // open add model
    const handleOpenAdd = () => setOpenAdd(true);
    const handleCloseAdd = () => setOpenAdd(false);

    // open add model
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    // open delete model
    const handleOpenDelete = () => setOpendelete(true);
    const handleCloseDelete = () => setOpendelete(false);

    // tab
    const handleChange = (event, newValue) => setValue(newValue);

    // toggleButton
    const toggleVisibilityClaim = () => setIsVisibleClaim(!isVisibleClaim);
    const toggleVisibilityNotes = () => setIsVisibleNotes(!isVisibleNotes);
    const toggleVisibilityProjectDoc = () => setIsVisibleProjectDoc(!isVisibleProjectDoc);

    const back = () => {
        navigate('/dashboard/project')
    }


    // fetch api
    const fetchData = async () => {
        setIsLoading(true)
        try {
            const result = await apiget(`api/project/view/${params.id}`);
            if (result && result.status === 200) {
                setProjectData(result?.data?.project[0]);
            }
        } catch (error) {
            console.error("Error fetching project data:", error);
        }
        setIsLoading(false)
    };

    // delete api
    const deletedata = async () => {
        await apidelete(`api/project/delete/${params.id}`)
        navigate('/dashboard/project')
    }

    const csvColumns = [
        { Header: "Project number", accessor: 'projectNumber' },
        { Header: "Project start date", accessor: 'projectStartDate', type: 'date' },
        { Header: "Project end date", accessor: 'projectEndDate', type: 'date' },
        { Header: "Project type", accessor: 'projectType' },
        { Header: "Project status", accessor: 'projectStatus' },
        { Header: "Project Amounts", accessor: 'projectAmounts' },
        { Header: "Client's name", accessor: 'clientName' },
        { Header: "Client's date of birth", accessor: 'clientDateOfBirth', type: 'date' },
        { Header: "Phone Number", accessor: 'phoneNumber' },
        { Header: "Email ", accessor: 'emailAddress' },
        { Header: "Project Cost amount", accessor: 'projectCost' },
        { Header: "Frequency of Project Cost payments", accessor: 'Frequency' },
        { Header: "Create Date", accessor: 'createdOn', type: 'date' },
    ];
    const formatDate = (dateString) => {
        return moment(dateString).format('DD/MM/YYYY HH:MM A')
    };

    const downloadCsvOrExcel = async (extension) => {
        const selectedFieldsData = {};
        csvColumns.forEach((item) => {
            if (item.type === 'date') {
                selectedFieldsData[item.accessor] = formatDate(projectData[item.accessor]);
            } else {
                selectedFieldsData[item.accessor] = projectData[item.accessor];
            }
        });

        const jsonArray = [selectedFieldsData];

        commonUtils.convertJsonToCsvOrExcel({ jsonArray, csvColumns, fileName: "Project", extension });
    };

    const handleExport = (extension) => {
        downloadCsvOrExcel(extension);
    };

    useEffect(() => {
        fetchData();
    }, [userAction])

    return (
        <div>
            {/* Add Model */}
            <AddModel open={openAdd} handleClose={handleCloseAdd} setUserAction={setUserAction} />

            {/* Edit Mode */}
            <EditModel open={openEdit} handleClose={handleCloseEdit} setUserAction={setUserAction} projectData={projectData} fetchProject={fetchData} />

            {/* open Delete Model */}
            <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deletedata} id={params.id} />

            <Container maxWidth>
                <Grid container display="flex" alignItems="center">
                    <Stack direction="row" alignItems="center" mb={3} justifyContent={"space-between"} width={"100%"}>
                        {
                            projectData?.contact_id ?
                                <Header
                                    title={!isLoading ? `${projectData?.contact_id?.firstName} ${projectData?.contact_id?.lastName}` : "Loading..."}
                                    subtitle="Project Details"
                                />
                                :
                                <Header
                                    title={!isLoading ? projectData?.clientName : "Loading..."}
                                    subtitle="Project Details"
                                />
                        }
                        <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
                            {/* Action Butoon */}
                            <Actionbutton
                                handleOpen={handleOpenAdd}
                                handleOpenEdit={handleOpenEdit}
                                handleOpenDelete={handleOpenDelete}
                                handleExport={() => handleExport("xlsx")}
                                back={back}
                            />
                        </Stack>
                    </Stack>
                </Grid>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "0px" }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="OVERVIEW" {...a11yProps(0)} />
                            <Tab label="MORE INFORMATION" {...a11yProps(1)} />
                            <Tab label="OTHER" {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Overview data={projectData} setUserAction={setUserAction} isLoading={isLoading} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Moreinformation data={projectData} isLoading={isLoading} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <Other data={projectData} isLoading={isLoading} />
                    </CustomTabPanel>
                </Box>


                {/* Notes Table */}
                <Card sx={{ marginTop: "50px" }}>
                    <Notes toggleVisibilityNotes={toggleVisibilityNotes} isVisibleNotes={isVisibleNotes} rows={projectData?.notes} _id={params.id} setUserAction={setUserAction} />
                </Card>

                {/* Claim Table */}
                <Card sx={{ marginTop: "20px" }}>
                    <Claim toggleVisibilityClaim={toggleVisibilityClaim} isVisibleClaim={isVisibleClaim} rows={projectData?.claims} _id={params.id} setUserAction={setUserAction} />
                </Card>

                {/* ProjectDoc Table */}
                <Card sx={{ marginTop: "20px" }}>
                    <ProjectDocuments toggleVisibilityProjectDoc={toggleVisibilityProjectDoc} isVisibleProjectDoc={isVisibleProjectDoc} rows={projectData?.projectdocuments} _id={params.id} setUserAction={setUserAction} />
                </Card>

            </Container>


        </div>
    )
}

export default View
